import * as Sentry from '@sentry/vue'
import Util from '@/util'
import cookie from '@/services/cookie'

export default {
  methods: {
    async canRedirectToBulkLicenseCheckoutPage(user) {
      try {
        const isLoggedIn = cookie.getValue('ahaToken') != null
        const isFromBulkLicenseCheckout = Util.getParamValue('bl_checkout', window.location.href)
        const bulkLicenseCheckoutDataForGoogleLogin = JSON.parse(window.localStorage.getItem('bl_checkout'))
        if (isFromBulkLicenseCheckout && isLoggedIn) {
          await this.createCheckoutSessionAction({
            plan: Util.getParamValue('bl_plan', window.location.href),
            quantity: parseInt(Util.getParamValue('bl_qty', window.location.href), 10),
            email: user.email,
          })
          return true
        }
        if (bulkLicenseCheckoutDataForGoogleLogin) {
          await this.createCheckoutSessionAction({
            plan: bulkLicenseCheckoutDataForGoogleLogin.plan,
            quantity: bulkLicenseCheckoutDataForGoogleLogin.quantity,
            email: user.email,
          })
          window.localStorage.removeItem('bl_checkout')
          return true
        }
        return false
      } catch (e) {
        Sentry.captureException(e)
        return false
      }
    },
  },
}
